<template>
	<AppTooltip position="bottom" :text="'Extension needed'">
		<SIcon :name="'puzzle-outline'" width="15" height="15" />
	</AppTooltip>
</template>

<script>
export default {
	name: 'ExtensionNeededTooltip',
};
</script>

<style lang="scss" scoped></style>
